export default __webpack_public_path__ + "images/741f871e98ed2f8faf9c9ce55e217908-alumni_small.webp";